import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["out", "in"]

  connect() {
    this.main = document.querySelector("#layout_wrapper")
    this.main = document.querySelector("#layout_wrapper")
    this.applyCurrentState()
  }

 toggle() {
    // Swap icons
    if (this.hasOutTarget && this.hasInTarget) {
      this.outTarget.classList.toggle("hidden")
      this.inTarget.classList.toggle("hidden")
    }

    // Toggle layout classes
    if (this.main) {
      this.main.classList.toggle("max-w-5xl")
      this.main.classList.toggle("max-w-full")
      this.main.classList.toggle("pr-10")
      this.main.classList.toggle("pl-10")
    }

    // Persist new state
    const isExpanded = this.main.classList.contains("max-w-full")
    this.saveState(isExpanded)
  }

  applyCurrentState() {
    fetch("/settings/widescreen", { headers: { "Accept": "application/json" } })
      .then(r => r.json())
      .then(({ widescreen_enabled }) => {
        if (!this.main) return

        if (widescreen_enabled) {
          this.main.classList.add("max-w-full", "pl-10", "pr-10")
          this.main.classList.remove("max-w-5xl")
          if (this.hasOutTarget && this.hasInTarget) {
            this.outTarget.classList.add("hidden")
            this.inTarget.classList.remove("hidden")
          }
        } else {
          this.main.classList.remove("max-w-full", "pl-10", "pr-10")
          this.main.classList.add("max-w-5xl")
          if (this.hasOutTarget && this.hasInTarget) {
            this.outTarget.classList.remove("hidden")
            this.inTarget.classList.add("hidden")
          }
        }
      })
  }

  saveState(isExpanded) {
    fetch("/settings/widescreen", {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("[name=csrf-token]").content,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ widescreen_enabled: isExpanded }),
    })
  }

}